/**
 * Inline error tile shown when a widget's data fetch fails. Carries
 * the message but does not surface stack traces (those land in Sentry
 * once Phase 6 wires it up).
 */
export interface ErrorStateProps {
  title?: string;
  message: string;
  height?: number;
}

export default function ErrorState(props: ErrorStateProps) {
  const { title = "Widget data unavailable", message, height = 140 } = props;
  return (
    <div
      role="alert"
      style={{
        background: "var(--bg-card)",
        border: "1px solid var(--flag-red)",
        borderRadius: 12,
        padding: "16px 20px",
        height,
        display: "grid",
        gap: 6,
        alignContent: "center",
      }}
    >
      <div
        style={{
          fontSize: 12,
          textTransform: "uppercase",
          letterSpacing: 0.5,
          color: "var(--flag-red)",
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.45 }}>{message}</div>
    </div>
  );
}
